<template>
    <div class="">
        <div>
            <div class="error-content">
                <div class="error-content-wrapper">
                    <div class="error-image-wrapper">    
                        <img src="@/assets/images/img-error-page.png" alt="error-image" />
                    </div>
               
                    <div class="error-title" v-html="errorTitle"></div>
                    <div class="error-message" v-html="errorMessage"></div>
                </div>
                <div class="error-actions">
                    <PrimaryButton
                        btnId="error-back-btn"
                        :btnMsg="lbl.default.close"
                        @clickButton="clickClose" />
                </div>
            </div>
        </div>
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import PrimaryButton from "@/components/Button/PrimaryButton.vue";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";

export default {
    name: 'ErrorPage',
    components: {
        PrimaryButton,
        ModalMaster
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    computed: {
        errorTitle: function () {
            return this.lbl.error.error_title || 'We’re sorry';
        },
        errorMessage: function () {
            return this.lbl.error.error_msg || 'Something went wrong. Please try again.';
        },
        deeplinks: function () {
            return this.$store.state.deeplinks || {};
        }
    },
    created: function () {
        this.initialModal();
    },
    methods: {
        clickBack: function () {
            window.location.reload();
        },
        clickClose: function () {
            var deepLink = this.deeplinks.back_to_privilege || '';
            if (deepLink) {
                window.location.href = deepLink;
            } else {
                window.location.reload();
            }
        },
        initialModal: function () {
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.loadingModal = modalFactory.getLoadingModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
        },
    }
}
</script>
<style lang="scss">
@import "./Error.scss";
</style>